import { useTranslation } from "react-i18next";
import { formatDateTime } from "src/utils/formatting";

export const useShortDateFormatter = () => {
    const { i18n } = useTranslation();

    return (isoDate: string) =>
        formatDateTime(new Date(isoDate), i18n.resolvedLanguage, { day: "2-digit", month: "2-digit", year: "numeric" });
};
